import React from 'react';
import enhance from './enhance';
import {
  ResponsiveContainer,
  BarChart,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
} from 'recharts';
import { Text } from '@vx/text';
import styles from './styles.module.scss';

export const CustomClusterLabel = props => {
  const { data, index, payload, visibleTicksCount, ...remainingProps } = props;
  return (
    <svg>
      <Text {...remainingProps} width={100} style={{ paddingBottom: '20px' }}>
        {data[index].status}
      </Text>
    </svg>
  );
};

export const PipelineChart = ({
  data,
  showPBOne,
  showPBTwo,
  showPBThree,
  showPBFour,
  showPBFive,
  togglePBOne,
  togglePBTwo,
  togglePBThree,
  togglePBFour,
  togglePBFive,
  priceBandData,
  formattedPriceBandSummary,
  resetFilters,
  clearFiltersLabel,
  priceBandLabel,
  priceBands,
  priceBandColors,
}) => (
  <div className={styles.pipelineChart}>
    <ResponsiveContainer width="100%" height="85%">
      <BarChart data={data} margin={{ top: 30, bottom: 20 }}>
        <XAxis
          tick={<CustomClusterLabel data={data} fontSize={12} />}
          tickLine={false}
          axisLine={false}
        />
        <YAxis tickLine={false} axisLine={false} allowDecimals={false} />
        <Tooltip labelFormatter={props => data[props].status} offset={60} />
        {showPBOne && (
          <Bar
            dataKey={`${priceBandLabel}${priceBands[0].id}`}
            fill={priceBandColors[0]}
          />
        )}
        {showPBTwo && (
          <Bar
            dataKey={`${priceBandLabel}${priceBands[1].id}`}
            fill={priceBandColors[1]}
          />
        )}
        {showPBThree && (
          <Bar
            dataKey={`${priceBandLabel}${priceBands[2].id}`}
            fill={priceBandColors[2]}
          />
        )}
        {showPBFour && (
          <Bar
            dataKey={`${priceBandLabel}${priceBands[3].id}`}
            fill={priceBandColors[3]}
          />
        )}
        {showPBFive && (
          <Bar
            dataKey={`${priceBandLabel}${priceBands[4].id}`}
            fill={priceBandColors[4]}
          />
        )}
      </BarChart>
    </ResponsiveContainer>
    <div className={styles.filterContainer}>
      <div className={styles.filterSection}>
        <button
          onClick={togglePBOne}
          className={showPBOne ? styles.inactiveFilter : styles.activeFilter}
        >
          <svg width="12" height="12">
            <rect
              width="12"
              height="12"
              style={{
                fill: priceBandColors[0],
                strokeWidth: 3,
                stroke: priceBandColors[0],
              }}
            />
          </svg>
          {formattedPriceBandSummary[priceBands[0].id]['priceBandName']}{' '}
          {formattedPriceBandSummary[priceBands[0].id]['priceRange']} (
          {formattedPriceBandSummary[priceBands[0].id]['sumAcrossPipeline']})
        </button>
        <button
          onClick={togglePBTwo}
          className={showPBTwo ? styles.inactiveFilter : styles.activeFilter}
        >
          <svg width="12" height="12">
            <rect
              width="12"
              height="12"
              style={{
                fill: priceBandColors[1],
                strokeWidth: 3,
                stroke: priceBandColors[1],
              }}
            />
          </svg>
          {formattedPriceBandSummary[priceBands[1].id]['priceBandName']}{' '}
          {formattedPriceBandSummary[priceBands[1].id]['priceRange']} (
          {formattedPriceBandSummary[priceBands[1].id]['sumAcrossPipeline']})
        </button>
        <button
          onClick={togglePBThree}
          className={showPBThree ? styles.inactiveFilter : styles.activeFilter}
        >
          <svg width="12" height="12">
            <rect
              width="12"
              height="12"
              style={{
                fill: priceBandColors[2],
                strokeWidth: 3,
                stroke: priceBandColors[2],
              }}
            />
          </svg>
          {formattedPriceBandSummary[priceBands[2].id]['priceBandName']}{' '}
          {formattedPriceBandSummary[priceBands[2].id]['priceRange']} (
          {formattedPriceBandSummary[priceBands[2].id]['sumAcrossPipeline']})
        </button>
        <button
          onClick={togglePBFour}
          className={showPBFour ? styles.inactiveFilter : styles.activeFilter}
        >
          <svg width="12" height="12">
            <rect
              width="12"
              height="12"
              style={{
                fill: priceBandColors[3],
                strokeWidth: 3,
                stroke: priceBandColors[3],
              }}
            />
          </svg>
          {formattedPriceBandSummary[priceBands[3].id]['priceBandName']}{' '}
          {formattedPriceBandSummary[priceBands[3].id]['priceRange']} (
          {formattedPriceBandSummary[priceBands[3].id]['sumAcrossPipeline']})
        </button>
        <button
          onClick={togglePBFive}
          className={showPBFive ? styles.inactiveFilter : styles.activeFilter}
        >
          <svg width="12" height="12">
            <rect
              width="12"
              height="12"
              style={{
                fill: priceBandColors[4],
                strokeWidth: 3,
                stroke: priceBandColors[4],
              }}
            />
          </svg>
          {formattedPriceBandSummary[priceBands[4].id]['priceBandName']}{' '}
          {formattedPriceBandSummary[priceBands[4].id]['priceRange']} (
          {formattedPriceBandSummary[priceBands[4].id]['sumAcrossPipeline']})
        </button>
      </div>
      <span className={styles.clearFilters} onClick={resetFilters}>
        {clearFiltersLabel}
      </span>
    </div>
  </div>
);

export default enhance(PipelineChart);
